import { Link } from "react-router-dom";
import { ArrowUpRight, Building2 } from "lucide-react";
import { useFetch } from "@/hooks/useFetch";
import { money } from "@/lib/api";

export default function PlatformGlance() {
  const { data } = useFetch("/platform/overview");
  if (!data) return null;
  const t = data.totals;
  const cells = [["Workspaces", t.workspaces], ["Trialing", t.trialing], ["Paying", t.active], ["MRR", money(t.mrr).replace("CA", "")]];
  return (
    <section className="mb-10 rounded-2xl border bg-card p-6" data-testid="platform-glance">
      <div className="flex items-center justify-between gap-3">
        <p className="eyebrow flex items-center gap-2"><Building2 className="h-4 w-4" />E.L.M at a glance</p>
        <Link to="/platform" className="inline-flex items-center gap-1 text-sm underline underline-offset-4" data-testid="platform-glance-link">All workspaces <ArrowUpRight className="h-3.5 w-3.5" /></Link>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-4 sm:grid-cols-4">
        {cells.map(([l, v]) => <div key={l}><p className="text-xs uppercase tracking-wider text-muted-foreground">{l}</p><p className="stat text-2xl" data-testid={`glance-${l.toLowerCase()}`}>{v}</p></div>)}
      </div>
    </section>
  );
}
